var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCard',{staticClass:"mx-auto mt-8",attrs:{"max-width":"1200px","outlined":""}},[_c('VCardTitle',[_vm._v(_vm._s(_vm.$t('organization.pageTitle')))]),_c('VCardText',[_c('OrganizationCreate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }